import React, { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import Demo from "./demo";
// import { withWindow, WindowManager } from "../../src/index";

// // Example breakpoints data
// const BREAKPOINTS = [
//   {
//     name: "small",
//     media: "(min-width: 0)",
//   },
//   {
//     name: "medium",
//     media: "(min-width: 600px)",
//   },
// ];

// Set breakpoints data
// Somewhere in your application bootstrap
// new WindowManager(BREAKPOINTS);

// class Demo extends React.Component {
//   render() {
//     return (
//       <div>
//         <div>
//           Window dimensions are: {this.props.dimensions.width}x{this.props.dimensions.height}
//         </div>
//         <div>Window orientation is: {this.props.orientation}</div>
//         <div>Window breakpoint is: {this.props.breakpoint}</div>
//         <div>Device is touch enabled: {this.props.isTouchDevice.toString()}</div>
//       </div>
//     );
//   }
// }

// function Demo(props) {
//   return (
//     <div>
//       <div>
//         Window dimensions are: {props.dimensions.width}x{props.dimensions.height}
//       </div>
//       <div>Window orientation is: {props.orientation}</div>
//       <div>Window breakpoint is: {props.breakpoint}</div>
//       <div>Device is touch enabled: {props.isTouchDevice.toString()}</div>
//     </div>
//   );
// }

// const DemoWithWindow = withWindow(Demo);

const container = document.getElementById("demo");
const root = createRoot(container);

root.render(
  <StrictMode>
    <Demo />
  </StrictMode>
);
